export const sortFields = ['id', 'name', 'email', 'lastActivityAt', 'canAccessPlatform'] as const;

export const estimatorSortFields = ['name'] as const;

// oxlint-disable-next-line no-unused-vars
type _EstimatorSortFieldsSafetyNet<
	T extends (typeof sortFields)[number] = (typeof estimatorSortFields)[number],
> = T;

export const adminSortFields = ['name', 'email', 'lastActivityAt', 'canAccessPlatform'] as const;

// oxlint-disable-next-line no-unused-vars
type _AdminSortFieldsSafetyNet<
	T extends (typeof sortFields)[number] = (typeof adminSortFields)[number],
> = T;
